<!-- 用户问题记录管理 -->
<template>
  <div>
    <el-form :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="用户手机号"
                    label-width="90px">
        <el-input v-model="queryParams.phone"
                  placeholder="请输入用户手机号"
                  clearable
                  size="small"
                  @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="问题">
        <el-input v-model="queryParams.question"
                  placeholder="请输入问题"
                  clearable
                  size="small"
                  @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   size="mini"
                   @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-card>
      <el-table :data="tableData"
                align="center"
                style="width: 100%"
                :header-cell-style="{background: '#f8f8f9'}">
        <el-table-column label="编号"
                         align="center"
                         width="80">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="用户手机号"
                         align="center"
                         prop="phone"
                         min-width="140"
                         show-overflow-tooltip />
        <el-table-column label="问题"
                         align="center"
                         prop="question"
                         min-width="160"
                         show-overflow-tooltip />
        <el-table-column label="答案"
                         align="center"
                         prop="answer"
                         min-width="200"
                         show-overflow-tooltip />
        <el-table-column label="创建时间"
                         align="center"
                         min-width="150"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.created || scope.row.createTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pagination">
        <pagination v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList" />
      </el-row>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        phone: '',
        question: ''
      },
      total: 0,
      tableData: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    async getList() {
      const params = {
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize
      }
      if (this.queryParams.phone) params.phone = this.queryParams.phone
      if (this.queryParams.question) params.question = this.queryParams.question
      const { data: res } = await this.$http.get('/admin/userQuestion/getUserQuestionList', { params })
      if (res.code != 200) return this.$message.error(res.msg)
      const data = res.data || {}
      this.tableData = Array.isArray(data) ? data : data.list || []
      this.total = Array.isArray(data) ? data.length : data.total || 0
    }
  }
}
</script>
<style lang='scss' scoped>
.pagination {
  padding-top: 10px;
  text-align: right;
}
</style>
